import React from 'react';
import PropTypes from 'prop-types';

const { default: styled } = require('@emotion/styled');
const { Avatar } = require('@mui/material');

const StyledAvatar = styled(Avatar)`
  background-color: ${({ theme, color }) => theme.palette[color || 'primary'].main};
  color: ${({ theme, color }) => theme.palette[color || 'primary'].main};

  opacity: .5;

  position: relative;
  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    background-color: #fff;
    opacity: 0.8;
  }

  svg {
    position: relative;
  }
`;

const SquareAvatarIcon = ({ Icon, color, variant = 'rounded' }) => {
  return (
    <StyledAvatar variant={variant || 'rounded'} color={color}>
      <Icon />
    </StyledAvatar>
  );
};

SquareAvatarIcon.propTypes = {
  Icon: PropTypes.elementType,

  variant: PropTypes.oneOf(['rounded', 'square']),
  color: PropTypes.string,
};

export default SquareAvatarIcon;
